import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addProjectDataTableHandler,
  deleteHandler,
  updateHandler,
} from "../../apiParsing/data";
import {
  filterClientsHandler,
  formModalController,
  listingCommonDefaulter,
} from "../../helpers/commonHelpers";
import { addActionColumn } from "../../helpers/companyHelpers";
import { apipaths } from "../../services/apiPaths";
import { notesListAction } from "../actions/notesAction";
import TableCard from "../TableCard";
import { useLocation } from "react-router-dom";
import { BsFillPencilFill, BsFillTrashFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import {
  notesProjectFormLayout,
  notesProjectFormLayoutJap,
} from "../../Data/FormsLayout/notesFormLayout";
import useTranslation from "../customHooks/translations";
import { employeesListAction } from "../actions/employeesListAction";
import { clientListAction } from "../actions/clientAction";
import { projectListAction } from "../actions/projectAction";
import moment from "moment";

export default function NotesProjectTable({ setModal, projectId }) {
  const dispatch = useDispatch();
  const { notes } = useSelector((state) => state.notes);
  const { employees } = useSelector((state) => state.employee);
  const { clients } = useSelector((state) => state.client);
  const { companies } = useSelector((state) => state.company);
  const { projects } = useSelector((state) => state.project);
  const [data, setData] = useState([]);

  const nameProject = projects.filter((d) => {
    return d.project_id === parseInt(projectId);
  });
  const companyId = nameProject[0]?.company_id;
  const clientId = nameProject[0]?.client_id;
  const location = useLocation();
  const translation = useTranslation();

  useEffect(() => {
    if (notes && projectId) {
      setData(notes.filter((m) => m.project_id === parseInt(projectId)));
    }
  }, [notes]);

  useEffect(() => {
    if (employees && projects && clients && companies) {
      const arr = [employees, projects, clients, companies];
      const keyArr = ["employee_id", "project_id", "client_id", "company_id"];
      listingCommonDefaulter(arr, notesProjectFormLayout, keyArr);
    }

    if (employees && projects && clients && companies) {
      const arr = [employees, projects, clients, companies];
      const keyArr = ["employee_id", "project_id", "client_id", "company_id"];
      listingCommonDefaulter(arr, notesProjectFormLayoutJap, keyArr);
    }
  }, [employees, projects, clients, companies]);

  useEffect(() => {
    dispatch(notesListAction());
  }, []);

  const notesColumns = [
    {
      title: "ID",
      dataIndex: "note_id",
      sorter: (a, b) => a.note_id - b.note_id,
    },
    {
      title: "Title",
      dataIndex: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      render: (d, data) => {
        return (
          <>
            <label
              style={{ color: "#1890ff" }}
              onClick={() => {
                dataTest(data);
              }}
            >
              {data.title}
            </label>
          </>
        );
      },
    },
    {
      title: "Entry Date",
      dataIndex: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
    },

    {
      title: "Employee",
      dataIndex: "employee_id",
      sorter: (a, b) => a.employee_id - b.employee_id,
      render: (employee_id, row) => {
        const employee = row["employee"];
        if (employee) return employee.first_name + " " + employee.last_name;
        else return "";
      },
    },
    {
      title: "Projects",
      dataIndex: "project",
      sorter: (a, b) => a.project.name.localeCompare(b.project.name),

      render: (d, data) => {
        return <>{data?.project?.name}</>;
      },
    },
    {
      title: "Client",
      dataIndex: "client",
      sorter: (a, b) =>
        a?.client?.first_name.localeCompare(b?.client?.first_name),
      render: (d, data) => {
        return (
          <>
            {data?.client?.first_name && data?.client?.last_name
              ? data?.client?.first_name + " " + data?.client?.last_name
              : "-"}
          </>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (data) => (
        <div>
          {" "}
          <span>
            <Link to="/notes/form/edit">
              <BsFillPencilFill className="table-icons edit-icon text-warning" />
            </Link>
            <BsFillTrashFill className="table-icons delete-icon text-danger" />
          </span>{" "}
        </div>
      ),
    },
  ];

  const notesColumnsHome = [
    {
      title: "ID",
      dataIndex: "note_id",
      sorter: (a, b) => a.note_id - b.note_id,
    },
    {
      title: "題名",
      dataIndex: "title",

      sorter: (a, b) => a.title.localeCompare(b.title),
      render: (d, data) => {
        return (
          <>
            <label
              style={{ color: "#1890ff" }}
              onClick={() => {
                dataTest(data);
              }}
            >
              {data.title}
            </label>
          </>
        );
      },
    },
    {
      title: "職員",
      dataIndex: "employee_id",
      sorter: (a, b) => a.employee_id - b.employee_id,
      render: (employee_id, row) => {
        const employee = row["employee"];
        if (employee) return employee.first_name + " " + employee.last_name;
        else return "";
      },
    },
    {
      title: "クライアント",
      dataIndex: "client",
      sorter: (a, b) =>
        a?.client?.first_name.localeCompare(b?.client?.first_name),
      render: (d, data) => {
        return (
          <>
            {data?.client?.first_name && data?.client?.last_name
              ? data?.client?.first_name + " " + data?.client?.last_name
              : "-"}
          </>
        );
      },
    },
    {
      title: "日付",
      dataIndex: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
    },
    {
      title: "プロジェクト",
      dataIndex: "project",
      sorter: (a, b) => a.project.name.localeCompare(b.project.name),

      render: (d, data) => {
        return <>{data?.project?.name}</>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (data) => (
        <div>
          {" "}
          <span>
            <Link to="/notes/form/edit">
              <BsFillPencilFill className="table-icons edit-icon text-warning" />
            </Link>
            <BsFillTrashFill className="table-icons delete-icon text-danger" />
          </span>{" "}
        </div>
      ),
    },
  ];

  const dataTest = (data) => {
    formModalController(
      setModal,
      notesProjectFormLayout,
      notesProjectFormLayoutJap,
      `${translation.edit_note}` + " " + "-" + " " + `${nameProject[0].name}`,
      `edit-note-form`,
      data,
      (data) =>
        updateHandler(
          apipaths.addnotes,
          data,
          "note_id",
          setModal,
          dispatch,
          notesListAction
        )
    );
  };

  return (
    <TableCard
      button={{
        title: translation.add_note,
        onClick: () =>
          formModalController(
            setModal,
            notesProjectFormLayout,
            notesProjectFormLayoutJap,
            `${translation.add_note}` +
              " " +
              "-" +
              " " +
              `${nameProject[0].name}`,
            `add-note-form`,
            {},
            (data) =>
              addProjectDataTableHandler(
                apipaths.addnotes,
                data,
                setModal,
                dispatch,
                notesListAction,
                projectId,
                clientId,
                companyId
              )
          ),
      }}
      columns={addActionColumn(
        {},
        notesColumns,
        (data) =>
          formModalController(
            setModal,
            notesProjectFormLayout,
            notesProjectFormLayoutJap,
            `${translation.edit_note}` +
              " " +
              "-" +
              " " +
              `${nameProject[0].name}`,
            `edit-note-form`,
            data,
            (data) =>
              updateHandler(
                apipaths.addnotes,
                data,
                "note_id",
                setModal,
                dispatch,
                notesListAction
              )
          ),
        (data) =>
          deleteHandler(
            apipaths.deleteNote,
            data?.["note_id"],
            setModal,
            dispatch,
            notesListAction
          ),
        translation._language
      )}
      jaCol={addActionColumn(
        {},
        notesColumnsHome,
        (data) =>
          formModalController(
            setModal,
            notesProjectFormLayout,
            notesProjectFormLayoutJap,
            `${translation.edit_note}` +
              " " +
              "-" +
              " " +
              `${nameProject[0].name}`,
            `edit-note-form`,
            data,
            (data) =>
              updateHandler(
                apipaths.addnotes,
                data,
                "note_id",
                setModal,
                dispatch,
                notesListAction
              )
          ),
        (data) =>
          deleteHandler(
            apipaths.deleteNote,
            data?.["note_id"],
            setModal,
            dispatch,
            notesListAction
          ),
        translation._language
      )}
      title={translation.notes}
      data={data}
    />
  );
}
